import React from 'react'
import { Avatar, withStyles } from '@material-ui/core'
import { useEffect } from 'react'
import { useState } from 'react'

function useIsMounted() {
  const isMounted = React.useRef(true)

  React.useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  return isMounted;
}

const styles = (theme) => ({
  textDecoration: 'none'
})

function CustomAvatar(props) {
  const { classes, theme, ...other } = props

  const [isInitialized, setIsInitialized] = useState(false)
  const [source, setSource] = useState(undefined)

  const isMounted = useIsMounted()

  useEffect(() => {
    if (!isInitialized) {
      var image = new Image()
      image.onload = () => {
        if (isMounted.current) {
          setSource(props.src)
        }
      }
      image.onerror = () => {
        if (isMounted.current) {
          setSource(undefined)
        }
      }
      image.src = props.src
      setIsInitialized(true)
    }
  }, [isInitialized])

  return (
    <Avatar
      { ...{ ...other, src: source } }
      className={props.className}
      style={{
        backgroundColor: !source ? theme.palette.primary.light : undefined
      }}
    >
      {!source && props.name ? props.name[0].toUpperCase() : undefined}
    </Avatar>
  )
}

export default withStyles(styles, { withTheme: true })(CustomAvatar)


// WEBPACK FOOTER //
// ./src/Parts/CustomAvatar/CustomAvatar.js